import React from 'react';

function WarningIcon({ width = 22, height = 21, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 22 21">
      <g>
        <path d="M10.830014,0.113300352 C11.3126755,-0.141991149 11.9076005,0.0486767989 12.1588162,0.539169134 L12.1588162,0.539169134 L21.8887114,19.5365448 C21.9618256,19.6792983 22,19.8378589 22,19.9987909 C22,20.5517434 21.5589,21 21.0147755,21 L21.0147755,21 L0.985407129,21 C0.819151003,21 0.655598624,20.9572444 0.509980721,20.8757148 C0.0334012036,20.608884 -0.140087176,19.9999627 0.122483579,19.515651 L0.122483579,19.515651 L10.4219567,0.518275413 C10.5157086,0.345350212 10.657678,0.204453084 10.830014,0.113300352 Z M11.1204065,16.3370355 C10.3322269,16.3370355 9.6859196,16.9457707 9.6859196,17.7307186 C9.6859196,18.4996472 10.3322269,19.1083823 11.1204065,19.1083823 C11.9085861,19.1083823 12.5548934,18.4996472 12.5548934,17.7307186 C12.5548934,16.9457707 11.9085861,16.3370355 11.1204065,16.3370355 Z M12.413021,7.51037618 L9.85931911,7.51037618 L10.2061181,15.3918941 L12.066222,15.3918941 L12.413021,7.51037618 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default WarningIcon;
